class HeaderEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const menuOpenTrigger = document.querySelector(".js-header-mega")
    const menuOpenContent = document.querySelector(".js-header__modal")
    const menuPlusIcon = document.querySelectorAll(".js-mega-plus")

    menuOpenTrigger.addEventListener("mouseover", () => {
      menuOpenContent.classList.add("is-active")
      menuPlusIcon.forEach(ele => {
        ele.classList.add("is-active")
      });

    })
    menuOpenTrigger.addEventListener("mouseleave", () => {
      menuOpenContent.classList.remove("is-active")
      menuPlusIcon.forEach(ele => {
        ele.classList.remove("is-active")
      });
    })


    const headerContainer = document.querySelector(".js-header")
    window.addEventListener('scroll', function(){
      if(1 <= window.scrollY){
        headerContainer.classList.add("is-scroll")
      }else{
        headerContainer.classList.remove("is-scroll")
      }
    });

    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.ham-trigger-is-appear').click(function(){
        if($(this).text() == '＋開く'){
          $(this).text('×');
        }else{
          $(this).text('＋開く');
        }
        $(this).next('.is-appear').slideToggle();
      }
      );

      const headerTrigger = document.querySelector(".js-header-hamMenu")
      const menuContainer = document.querySelector(".ham-menu")
      const menuLink = document.querySelectorAll(".ham-menu a[href*='#']")

      headerTrigger.addEventListener("click", () => {
        if(!headerContainer.classList.contains("is-scroll")){
          headerContainer.classList.add("is-scroll")
        }

        menuContainer.classList.toggle("is-active")
        headerTrigger.classList.toggle("is-active")
        headerContainer.classList.toggle("is-active")

        scrollBan();

      })

      menuLink.forEach((el) => {
        el.addEventListener('click', (e) => {
          let href = e.target.getAttribute('href');
          href = href.split('#')[1];
          if(document.querySelector(`#${href}`)) {
            menuContainer.classList.toggle("is-active")
            headerTrigger.classList.toggle("is-active")
            headerContainer.classList.toggle("is-active")
            
            scrollBan();
          }
        })
      })
    }


    // スムーススクロール

    // // 固定ヘッダーの高さ（＋追加したい余白）
    // var headerHeight = jQuery('js-header').outerHeight() + 120;

    // // ページ内のアンカーへスクロール
    // jQuery('a[href*="#"]').click(function () {
    //   var target = jQuery(this.hash === '' ? 'html' : this.hash);
    //   var position = target.offset().top - headerHeight;
    //   if (target.length) {
    //     jQuery('html, body').animate({scrollTop:position}, 500, 'swing');

    //     // #タグをURLに残す場合は削除
    //     return false;
    //   }
    // });

    // // ページ外のアンカーへスクロール
    // var urlHash = location.hash;
    // // console.log(urlHash);
    // if(urlHash) {
    //   var target = jQuery(urlHash);
    //   var position = target.offset().top - headerHeight;
    //   // どこからスクロールさせるか ※一番上ならscrollTop(0)
    //   jQuery('body,html').stop().scrollTop(position - 200);
    //   setTimeout(function(){
    //     jQuery('body,html').stop().animate({scrollTop:position}, 500, 'swing');
    //   }, 100);
    // }

  }
}